export const getInAppModalConfig = (metadata = {}) => {
  const nested = metadata?.inAppModal || metadata?.in_app_modal || {};

  return {
    enabled: Boolean(
      nested?.enabled ??
      metadata?.inAppModalEnabled ??
      metadata?.in_app_modal_enabled
    ),
    buttonLabel:
      nested?.buttonLabel ||
      nested?.button_label ||
      metadata?.inAppModalButtonLabel ||
      metadata?.in_app_modal_button_label ||
      "",
  };
};

export const isInAppModalNotification = (notification) =>
  Boolean(getInAppModalConfig(notification?.metadata || {}).enabled);
